import Image from "next/image";
import React, { useState } from "react";
import { MdOutlineNavigateNext } from "react-icons/md";

const CardMobile = ({ item, showOpen = false, onClick = () => {} }) => {
  const [showPoster, setShowPoster] = useState(true);
  const [firstView, setFirstView] = useState("text");

  return (
    <div className="relative w-full flex items-center justify-between">
      {/* Video Container */}
      <div
        onClick={() => setFirstView("video")}
        className={`rounded-2xl overflow-hidden aspect-video w-full md:w-[600px] lg:w-[1000px] ${firstView === "video" ? "z-50" : "z-10"}`}
      >
        {showPoster && item?.poster ? (
          <div
            onClick={() => item?.videoUrl && setShowPoster(false)}
            className="relative w-full h-full"
          >
            <Image
              width={0}
              height={0}
              sizes="100vh"
              className="object-cover h-full w-full"
              src={item?.poster}
              alt="poster"
              layout="responsive"
              priority
            />
            <div className="absolute top-0 left-0 h-full w-full bg-black bg-opacity-40 flex items-center justify-center rounded-2xl" />
          </div>
        ) : (
          <iframe
            width="100%"
            height="100%"
            src={item?.videoUrl}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          />
        )}
      </div>
      {/* Text Container */}
      <div
        onClick={() => setFirstView("text")}
        className={`h-72 absolute top-44 w-full md:w-1/2 bg-white bg-opacity-90 p-6 rounded-2xl shadow-2xl flex flex-col justify-center ${
          firstView === "text" ? "z-50" : "z-10"
        }`}
      >
        {showOpen ? (
          <p
            onClick={onClick}
            className={`text-xl font-semibold text-gray-900 mb-4 line-clamp-2 hover:cursor-pointer hover:underline`}
          >
            {item?.title || "Default Title"}
          </p>
        ) : (
          <p
            className={`text-xl font-semibold text-gray-900 mb-4 line-clamp-2`}
          >
            {item?.title || "Default Title"}
          </p>
        )}
        <p className="text-gray-700 leading-relaxed line-clamp-5">
          {item?.description ||
            "Default description text to fill in placeholder space."}
        </p>
        {showOpen && (
          <div
            onClick={onClick}
            className="ml-auto mt-auto hover:cursor-pointer"
          >
            <MdOutlineNavigateNext color={"#6E6E6E"} size={40} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CardMobile;
